import { Component, EventEmitter, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Toast, ToastsManager } from 'ng2-toastr/ng2-toastr';

import { Finance } from 'financejs';
// import Loan from '../models/loan';
import { BudgetService } from '../service/budget.service';
import { CompanyService } from '../service/company.service';
import { LoanService } from '../service/loan.service';
import { OperatingexpensesService } from '../service/operatingexpenses.service';
import { ProjectService } from '../service/project.service';

@Component({
  selector: 'app-financing',
  templateUrl: './financing.component.html',
  styleUrls: ['./financing.component.css'],
})
export default class FinancingComponent implements OnInit {
  constructor(
    private loanService: LoanService,
    private companyService: CompanyService,
    private projectService: ProjectService,
    private budgetService: BudgetService,
    private operatingexpensesService: OperatingexpensesService,
    private route: ActivatedRoute,
    private router: Router,
    vRef: ViewContainerRef,
    private toastr: ToastsManager,
    public fb: FormBuilder
  ) {
    this.toastr.setRootViewContainerRef(vRef);
    this.print = false;
    this.showInstructions = false;
    this.projectId = localStorage.getItem('projectId');
    this.companyId = localStorage.getItem('companyId');
    // this.getProjectData();
    this.getCompanyData();
  }

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @Input() print: boolean;

  @Output() projectEmitFinancing: EventEmitter<any> = new EventEmitter();

  @Output() budgetEmitFinancing: EventEmitter<any> = new EventEmitter();

  @Output() loanEmitFinancing: EventEmitter<any> = new EventEmitter();

  // DECLARATION OF ALL VARIABLES
  projectId: string;

  companyId: string;

  projectName: string;

  companyLogoUrl = '';

  businessType = '';

  userid = '';

  businessPurchasePrice = 0;

  realEstatePurchasePrice = 0;

  costPerSquareFeet = 0;

  landAcquisitionCost = 0;

  operatingCapital = 0;

  operatingCapitalInt = 0;

  maintenanceReserve = 0;

  realEstateBudgetTotal = 0;

  totalProjectCost = 0;

  totalFunds = 0;

  ownerContribution = 0;

  ownerContributionInt = 0;

  total_Project_Cost = 0;

  investmentTitle = '';

  investmentName = '';

  loanAmount = 0;

  futureValue = 0;

  futureStartPoint = 0;

  interestRate = 0;

  term: number;

  monthlyPayment: any = 0;

  realEstateSubTotal = 0;

  interiorSubTotal = 0;

  exteriorSubTotal = 0;

  specialItemsSubTotal = 0;

  professionalSubTotal = 0;

  total_loan_investment = 0;

  loanArray = [];

  selectionAvailableLoans = [];

  updateLoanId = '';

  showLoanElement = false;

  showInvestmentElement = false;

  investors: string[] = [];

  investorsArray = [];

  count = 0;

  reportData = [];

  showInstructions: boolean;

  ngOnInit() {
    this.getBudgetData();

    // WILL EXECUTE ONLY IN CASE OF PRINTING TO SHOW SELECETD INVESTORS
    if (print) {
      this.getInvestors();
    }
    this.getLoansData();

    this.showLoanElement = false;
    this.showInvestmentElement = false;
    const data = { projectId: this.projectId };
    this.operatingexpensesService.updateCashFlow(data).subscribe();
  }

  // GET SELECTED INVESTORS TO SHOW IN PRINTING FUNCTIONALITY ONLY
  getInvestors() {
    const self = this;
    this.investorsArray = [];
    this.investors = JSON.parse(localStorage.getItem('investors_id'));

    if (this.investors && this.investors.length > 0) {
      for (let i = 0; i < this.investors.length; i += 1) {
        this.loanService.getLoan(this.investors[i]).subscribe((loanData) => {
          this.investorsArray.push(loanData.data[0]);
        });
      }
      this.loanEmitFinancing.emit({ loanEmitFinancing: true });
    } else {
      this.loanService.getLoans(this.projectId).subscribe((loanData) => {
        for (let i = 0; i < loanData.data.length; i += 1) {
          this.investorsArray.push(loanData.data[i]);
        }
        this.loanEmitFinancing.emit({ loanEmitFinancing: true });
      });
    }
  }

  // GET SAVED LOANS DATA FROM DB
  getLoansData(): Promise<Boolean> {
    const self = this;
    return new Promise((resolve, reject) => {
      this.loanService.getLoans(this.projectId).subscribe((loanData) => {
        //
        // TODO: The return array literally contains a property named "monthly_payment_show", which is the value formatted
        // as it should be shown, i.e., in a round dollar amount.
        //
        this.loanArray = loanData.data;
        this.count = this.loanArray.length;
        this.selectionAvailableLoans = [];
        for (let i = 0; i < loanData.data.length; i += 1) {
          if (loanData.data[i].option_selected === 0 && loanData.data[i].investment_title !== '') {
            this.selectionAvailableLoans.push(loanData.data[i]);
          }
        }

        if (loanData.data.length === 0) {
          this.total_loan_investment = 0;
        } else {
          let totalAmount = 0;
          for (let i = 0; i < loanData.data.length; i += 1) {
            totalAmount += +(loanData.data[i].loan_amount + loanData.data[i].additional_investment);
          }
          this.total_loan_investment = isNaN(totalAmount) ? 0 : totalAmount;
        }
        // EMITTER IS USED TO EMIT EVENT WHEN ALL DATA IS LOADED IN CASE OF PRINTING ONLY
        this.loanEmitFinancing.emit({ loanEmitFinancing: true });
        resolve(true);
      });
    });
  }

  // TO GET COMPANY LOGO DATA FROM DB THROUGH COMPANY SERVICE
  getCompanyData() {
    this.companyService.getCompany(this.companyId).subscribe((res) => {
      this.companyLogoUrl = res.data[0].logoUrl;
      this.userid = res.data[0].userid;
    });
  }

  // GET BUDGET PAGE'S SAVED DATA FROM DB
  async getBudgetData() {
    await this.getProjectData();
    this.budgetService.getBudget(this.projectId).subscribe(async (budgetData) => {
      this.realEstatePurchasePrice = budgetData.data[0].real_estate_purchase_price;
      this.realEstateSubTotal = budgetData.data[0].total_realEstateSubTotal;
      this.interiorSubTotal = budgetData.data[0].total_interiorSubTotal;
      this.exteriorSubTotal = budgetData.data[0].total_exteriorSubTotal;
      this.specialItemsSubTotal = budgetData.data[0].total_specialItemsSubTotal;
      this.professionalSubTotal = budgetData.data[0].total_professionalSubTotal;
      this.businessPurchasePrice = budgetData.data[0].business_purchase_price;
      this.costPerSquareFeet = budgetData.data[0].cost_per_square_feet;
      this.landAcquisitionCost = budgetData.data[0].land_acquisition_cost;

      await this.realEstateTotal();
      await this.projectCost();
      await this.totalFundsNeed();

      // EMITTER IS USED TO EMIT EVENT WHEN ALL DATA IS LOADED IN CASE OF PRINTING ONLY
      this.budgetEmitFinancing.emit({ budgetEmitFinancing: true });
    });
  }

  // TO GET PROJECT DATA FROM PROJECT SERVICE FROM DB
  getProjectData() {
    this.projectService.getProject(this.projectId).subscribe((projectData) => {
      this.projectName = projectData.data[0].project_name;
      this.operatingCapital = projectData.data[0].operating_capital;
      this.operatingCapitalInt = projectData.data[0].operating_capital;
      this.maintenanceReserve = projectData.data[0].maintenance_reserve;
      this.ownerContribution = projectData.data[0].owner_contribution;
      this.ownerContributionInt = projectData.data[0].owner_contribution;
      this.reportData = projectData.data[0].reportData;
      this.totalFunds = projectData.data[0].total_funds;
      // EMITTER IS USED TO EMIT EVENT WHEN ALL DATA IS LOADED IN CASE OF PRINTING ONLY
      this.projectEmitFinancing.emit({ projectEmitFinancing: true });
    });
  }

  // TO CALCULATE REAL ESTATE BUGDET TOTAL
  realEstateTotal() {
    this.realEstateBudgetTotal =
      this.realEstateSubTotal +
      this.interiorSubTotal +
      this.exteriorSubTotal +
      this.specialItemsSubTotal +
      this.professionalSubTotal;
  }

  // TO CALCULATE TOTAL PROJECT COST
  projectCost() {
    this.totalProjectCost = 0;
    this.totalProjectCost =
      +this.businessPurchasePrice +
      +this.operatingCapital +
      +this.maintenanceReserve +
      +this.realEstateBudgetTotal;
  }

  // TO CALCULATE TOTAL FUNDS REQUIRED
  totalFundsNeed() {
    this.totalFunds = 0;
    this.totalFunds = this.totalProjectCost - this.ownerContribution;
    const data = { fieldName: 'totalFunds', value: this.totalFunds };
    this.projectService.onChangeProject(this.projectId, data).subscribe((res) => {
      if (res.messageId === 200) {
      } else if (res.messageId === 400) {
        this.toastr.error(res.message, 'Error!');
      }
    });
  }

  // COMBINE ALL TOTAL FUNCTIONS
  totals() {
    this.realEstateTotal();
    this.projectCost();
    this.totalFundsNeed();
  }

  // TO UPDATE CAPITAL ACCOUNTS SECTION ONCHANGE OF FIELD VALUE BECAUSE THESE ARE PART OF PROJECT DATA PAGE AND WILL SAVE IN DIFFERENT TABLE
  onChange(event) {
    const fieldName = event.target.name;
    let value = FinancingComponent.replaceDollarsCommasPercentages(event.target.value);

    if (fieldName === 'operatingCapital') {
      if (value === '' || value === null) {
        this.operatingCapital = 0;
        value = 0;
      }
      if (value === this.operatingCapitalInt) {
        return;
      }
      this.operatingCapitalInt = value;
    } else if (fieldName === 'ownerContribution') {
      if (value === '' || value === null) {
        this.ownerContribution = 0;
        value = 0;
      }
      if (value === this.ownerContributionInt) {
        return;
      }
      this.ownerContributionInt = value;
    }

    const data = { fieldName, value };
    this.projectService.onChangeProject(this.projectId, data).subscribe((res) => {
      if (res.messageId === 200) {
        this.totals();
      } else if (res.messageId === 400) {
        this.toastr.error(res.message, 'Error!');
      }
    });
  }

  // TO ADD A NEW ENTRY OF LOAN INTO DB
  addLoan() {
    this.showInvestmentElement = false;
    this.showLoanElement = false;
    let array = [];
    const data = { projectId: this.projectId, userId: this.userid };
    this.loanService.saveLoan(data).subscribe(
      (loanData) => {
        if (loanData.messageId === 200) {
          this.getLoansData().then((success) => {
            array = this.loanArray;

            setTimeout(function () {
              document.getElementById(`label${array.length - 1}`).focus();
            }, 100);
          });
        } else if (loanData.messageId === 400) {
          this.toastr.error(loanData.message, 'Error!');
        }
      },
      (err) => {
        this.toastr.error(err, 'Error!');
      }
    );
  }

  // EXECUTE WHEN CLEAR BUTTON OF LOAN CLICKED
  clear(loan, type) {
    // if type is loan then clear only above table
    // otherwise clear 2nd table
    const data = { loan, projectId: this.projectId, type };
    this.loanService.clearLoan(data).subscribe(() => {
      // TODO: The proper fix would be to pass the project id into the clearLoan API and have it also redo the calculations
      // automatically on the backend. The quick fix for now, though, is just to explicitly make the API call to "save"
      // the debt amount, which is really "calculate the debt".
      this.projectService.saveDebt({ project_id: this.projectId }).subscribe(() => {
        this.getLoansData();
      });
    });
  }

  // CALCULATE LOAN'S VALUES ON CLICKING CALCULATE BUTTON OF FIRST SECTION OF LOAN
  calculate(loan) {
    const formval = loan;
    this.updateLoanId = loan._id;
    const keyValue = [];
    keyValue[0] = 'loanAmount';
    keyValue[1] = 'interestRate';
    keyValue[2] = 'term';
    keyValue[3] = 'monthlyPayment';
    keyValue[4] = 'futureValue';

    // const formValues: Loan = new Loan();
    const formValues = {};
    formval.loan_amount =
      formval.loan_amount === '' || isNaN(formval.loan_amount) ? null : formval.loan_amount;

    formval.interest_rate =
      formval.interest_rate === '' || isNaN(formval.interest_rate) ? null : formval.interest_rate;

    formval.monthly_payment =
      formval.monthly_payment === null || isNaN(formval.monthly_payment)
        ? null
        : formval.monthly_payment;

    formval.future_value =
      formval.future_value === null || isNaN(formval.future_value) ? null : formval.future_value;

    formValues['loanAmount'] = formval.loan_amount;
    formValues['interestRate'] = formval.interest_rate;
    formValues['term'] = formval.term !== '' ? formval.term : null;
    formValues['monthlyPayment'] = formval.monthly_payment;
    formValues['futureValue'] = formval.future_value;
    formValues['futureStartPoint'] =
      formval.future_start_point !== null ? formval.future_start_point : null;

    this.loanAmount = formval.loan_amount;
    this.interestRate = formval.interest_rate;
    this.term = formval.term !== '' ? formval.term : null;
    this.monthlyPayment = formval.monthly_payment;
    this.futureValue = formval.future_value;
    this.futureStartPoint =
      formval.future_start_point === null || isNaN(formval.future_start_point)
        ? null
        : formval.future_start_point;

    let j = 0;
    for (let i = 0; i <= 4; i += 1) {
      const val = formValues[keyValue[i]];
      if (val === null || isNaN(val)) {
        j += 1;
      }
    }
    if (j !== 1) {
      this.toastr.error('Make sure exactly one of first five fields is left blank, then retry.');
      return;
    }
    if (formValues['interestRate'] !== null) {
      const totalAmount = formValues['loanAmount'] * (1 + formValues['interestRate'] / 100);
    }
    if (formval.monthly_payment === null || isNaN(formval.monthly_payment)) {
      const principal = formValues['loanAmount'];
      const interest = formValues['interestRate'] / 100 / 12;
      const payments = formValues['term'];
      const futureValue = formValues['futureValue'];
      const roi = Math.pow(1 + interest, -payments);
      const upperValue1 = futureValue * roi;
      const uppervalue2 = principal - upperValue1;
      const upperValue = uppervalue2 * (formValues['interestRate'] / 100);
      const lowerValue1 = 1 - roi;
      const lowerValue = 12 * lowerValue1;
      this.monthlyPayment = (upperValue / lowerValue).toFixed(2);
    } else if (formValues['term'] === null) {
      /* formValues['loanAmount'] = totalAmount - formValues['futureValue'];
        var termCalculated = formValues['loanAmount'] /formValues['monthlyPayment'];
        this.term = termCalculated; */

      const principal = formValues['loanAmount'];
      const rate = formValues['interestRate'];
      const mp = formValues['monthlyPayment'];
      const upperValue = mp / ((mp - principal) * rate);

      this.term = Math.log10(upperValue) / Math.log10(1 + rate);
    } else if (formValues['interestRate'] === null) {
      const period = 89;

      const financed = 78777;

      const rental = 67;
      const IRRval = [];

      IRRval.push(-financed);
      for (let i = 0; i < period; i += 1) {
        IRRval.push(rental);
      }

      const IRR = this.IRRCalc(IRRval, 0.001) * 0.01;
      const val = ((formValues['loanAmount'] - formValues['futureValue']) / formValues['loanAmount']) * 100;
      const interestRateCalculated = 100 - val;
      this.interestRate = interestRateCalculated;
    } else if (formValues['loanAmount'] === null) {
      const futureValue = formValues['futureValue'];
      const interest = formValues['interestRate'] / 100 / 12;
      const payments = formValues['term'];
      const mp = formValues['monthlyPayment'];
      const roi = Math.pow(1 + interest, payments);

      const additionValue = (mp * (roi - 1)) / interest;

      this.loanAmount = Math.round((+futureValue + +additionValue) / roi);
    } else if (formValues['futureValue'] === null) {
      const interest = formValues['interestRate'] / 100 / 12;
      const monthlyPayment = formValues['monthlyPayment'];
      const payments = formValues['term'];

      //
      // If there is 0% interest, then the future value is just the starting loan amount - all the payments that are made
      // during the life of the loan. Otherwise, it's a more complicated equation.
      //
      if (interest === 0) {
        this.futureValue = this.loanAmount - monthlyPayment * payments;
      } else {
        const interestPayments = (1 + interest) ** payments;
        this.futureValue = Math.round(
          this.loanAmount * interestPayments - (monthlyPayment * (interestPayments - 1)) / interest
        );
      }
    }

    // }
    const loandata = {
      _id: this.updateLoanId,
      monthlyPayment: this.monthlyPayment,
      term: this.term,
      interestRate: this.interestRate,
      loanAmount: this.loanAmount,
      futureValue: this.futureValue,
      futureStartPoint: this.futureStartPoint,
      additional_investment: formval.additional_investment,
      duration: formval.duration,
      profit_share_exit: formval.profit_share_exit,
      profit_share_preferred: formval.profit_share_preferred,
      project_id: formval.project_id,
      userId: this.userid,
      loan_id: formval.loan_id,
      investment_name: formval.investment_name,
      reportData: this.reportData,
    };

    this.loanService.saveLoanData(loandata).subscribe(
      (loanData) => {
        if (loanData.messageId === 200) {
          this.toastr.error(
            'Total Distributions will be recalculated after more data is entered on other pages.'
          );
          this.getLoansData();

          // save for debt service
          // let data = {"startUpMonth":formval.future_start_point,"term":this.term,'project_id':this.projectId,'monthlyPayment':this.monthlyPayment}
          const data = { project_id: this.projectId };
          this.projectService.saveDebt(data).subscribe();
        } else if (loanData.messageId === 400) {
          this.toastr.error(loanData.message, 'Error!');
        }
      },
      (err) => {
        this.toastr.error(err, 'Error!');
      }
    );
  }

  // TO DELETE LOAN ENTRY FROM DB WHEN CLICKED ON TRASH BUTTON OF LOAN
  removeLoan(loan: any) {
    let array = [];
    const loanTitle = loan.investment_title ? loan.investment_title : 'Loan';
    if (confirm(`Are you sure you want to delete ${loanTitle} ?`)) {
      this.loanService.deleteLoan(loan.loan_id).subscribe((res) => {
        this.getLoansData().then((success) => {
          array = this.loanArray;
          if (array.length > 0) {
            setTimeout(function () {
              document.getElementById(`label${array.length - 1}`).focus();
            }, 100);
          }
        });
        const data = { project_id: this.projectId };
        this.projectService.saveDebt(data).subscribe();
      });
    }
  }

  //
  // This form supports multiple loans, all of which are stored in the loanArray property. The
  // HTML has to tell us which loan object is being modified so we store the value in the right place.
  //
  onKeyUp(event, loan) {
    const value = Number.parseFloat(FinancingComponent.replaceDollarsCommasPercentages(event.target.value));
    const fieldName = event.target.name;
    switch (fieldName) {
      case 'loanAmount':
        loan.loan_amount = value;
        break;
      case 'interestRate':
        loan.interest_rate = value;
        break;
      case 'term':
        loan.term = value;
        break;
      case 'monthlyPayment':
        loan.monthly_payment = value;
        break;
      case 'futureValue':
        loan.future_value = value;
        break;
      case 'futureStartPoint':
        loan.future_start_point = value;
        break;
    }
  }

  // TO UPDATE LOAN'S FIELDS ONCHANGE IN ORDER TO SAVE THEM IN DB
  onUpdate(loanId, event) {
    const { value } = event.target;
    const fieldName = event.target.name;
    const data = { fieldName, value };

    this.loanService.updateLoan(loanId, data).subscribe((res) => {
      if (res.messageId === 200) {
        if (fieldName === 'interestRate') {
          this.getLoansData();
        }
      } else {
        this.toastr.error('Error while updating', 'Error!');
      }
    });
  }

  // TO REMOVE DOLLER AND COMMAS FROM VALUES
  private static replaceDollarsCommasPercentages(value) {
    return value.replace(/[, $ %]+/g, '').trim();
  }

  IRRCalc(CArray, guest) {
    const inc = 0.000001;
    let NPV;
    do {
      guest += inc;
      NPV = 0;
      for (let j = 0; j < CArray.length; j += 1) {
        NPV += CArray[j] / Math.pow(1 + guest, j);
      }
    } while (NPV > 0);
    return guest * 100;
  }

  /* Removed as part of issue 19
  // CALCULATE LOAN'S VALUES ON CLICKING CALCULATE BUTTON FOR SECOND SECTION OF LOAN
  changeThis(event, fieldName, loan) {
    if (loan.is_calculated === 1) {
      if (loan.duration <= 0) {
        this.toastr.error('Warning, when 0 months is entered for the Term, no Profit sharing is possible', 'Error!');
        return;
      }
      const value = this.replaceDollarsCommasPercentages(event.target.value);
      const data = {value, fieldName, project_id: this.projectId, loan, reportData: this.reportData};
      this.loanService.updateProfitShares(data).subscribe(
        (loanData) => {
          this.toastr.error('Total Distributions will be recalculated after more data is entered on other pages.');
          this.getLoansData();
        }
      );
    } else {
      console.log('io');
    }
  }
  */

  // Open instructions in the nav bar when click on instructions button on header bar
  openModal() {
    if (this.showInstructions === true) {
      this.showInstructions = false;
    } else if (this.showInstructions === false) {
      this.showInstructions = true;
    }
  }

  // Close instructions in the nav bar when click on return button on header bar
  closeInstructions() {
    this.showInstructions = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/financing/financing.component.ts